import axios from 'axios';
import { getContentLanguage } from '~/Features/Configuration/Utils/languageUtils';

export const axiosWrapper = axios.create({
    paramsSerializer: {
        indexes: null, // key=value instead of key[]=value
    },
});

axiosWrapper.interceptors.request.use(config => {
    const contentLanguage = getContentLanguage();

    if (contentLanguage) {
        config.headers.set('X-Api-Language', contentLanguage);
    }

    return config;
});
